const WIDTH_CLASSES = {
  40: 'w-[40%]',
  55: 'w-[55%]',
  70: 'w-[70%]',
  85: 'w-[85%]',
} as const;

interface SkeletonBarProps {
  /** Width as a percentage of the cell. */
  width: keyof typeof WIDTH_CLASSES;
}

/** A grey bar standing in for a line of text. */
export function SkeletonBar({ width }: SkeletonBarProps) {
  return <span className={`block h-2 rounded-full bg-gray-100 ${WIDTH_CLASSES[width]}`} />;
}
